import React from 'react';
import { useLocation } from 'react-router-dom';
import { getPublicPageSeo } from '../../../seo/publicPages';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './ProductsHero.css';

const SECTION_MAP = {
  Task: 'Products > Task',
  Tasks: 'Products > Task',
  Documents: 'Products > Document',
  'Credentials Vault': 'Products > Credentials Vault',
  Projects: 'Products > Projects',
  'Discussion Forum': 'Products > Discussion Forum',
  'Snap Bill': 'Products > Snap Bill',
};

const ProductsHero = ({ title = 'Products', subtitle = 'Task and Document management designed to streamline your business operations', bannerSection, children }) => {
  const { pathname } = useLocation();
  const seo = getPublicPageSeo(pathname);
  const pageTitle = seo?.pageTitle || title;
  const detail = seo?.heading;
  const section = bannerSection || SECTION_MAP[title];
  const { hasDynamicBanner, banners } = usePageBanners(section || null);
  const titleSectionClass = hasDynamicBanner
    ? 'products-hero-title-section products-hero-title-section--below-banner'
    : 'products-hero-title-section products-hero-title-section--standalone';

  return (
    <section className="products-hero">
      {hasDynamicBanner && <PageBanner banners={banners} />}
      <div className={titleSectionClass}>
        <div className="container">
          <div className="products-hero-content">
            <h1 className="products-title">
              {pageTitle}
            </h1>
            {detail ? (
              <p className="products-lead">
                {detail}
              </p>
            ) : !children ? (
              <p className="products-subtitle">
                {subtitle}
              </p>
            ) : null}
          </div>
        </div>
      </div>
      {children && (
        <div className="products-hero-subheading-section">
          <div className="container">
            <div className="products-subtitle products-subtitle-multi">
              {children}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductsHero;
